import { faRotateLeft } from '@fortawesome/pro-light-svg-icons'
import { useMemo } from 'react'
import { DisplayPriceGettingSpecificPriceParams } from '../../../../baseComponents/Displays/DisplayPrice'
import { permissionCheck } from '../../../../baseComponents/PermissionChecker/function'
import { TwinTableLink } from '../../../../baseComponents/TwinTable'
import { TableComponentProps } from '../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderBoolean, EditRow, DeleteRow, CustomRenderImageToolTip } from '../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useProductActiveDictionary from '../../../../utils/hooks/product/useProductActiveDictionary'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { getAllSpecificPriceRules } from '../../../../utils/reducers/getters'
import { ProductExtendedTyLong } from '../../types'
import { SpecificPriceRulesPayload } from '../../../../utils/reducers/products/specificPriceRules'
import { OnRowClick } from '../../../../baseComponents/TwinTable/VirtualTableListing/types'
import locations from '../../../../utils/globals/locations'


interface TableAddonsProps extends TableComponentProps {
    specificPriceRules: SpecificPriceRulesPayload
    onRowClick?: OnRowClick
 }

const TableAddons: React.FC<TableAddonsProps> = ({ setTableInstance, userPermissions, setOpened, onRowClick }) => {
    const { t } = useTwinTranslation()
    const specificPriceRules = getAllSpecificPriceRules()
    const { productActiveDict } = useProductActiveDictionary()
    const defaultSpecificPriceRuleId = useMemo(() => {
        const specificPriceRulesSorted = specificPriceRules?.arrSorted || []
        return specificPriceRulesSorted?.[0]?.id
    }, [specificPriceRules?.arrSorted])

    const columns: ColumnTableSchema<ProductExtendedTyLong> = [
        {
            id: 'ProductImages.url',
            dataKey: 'ProductImages.url',
            label: t('image', 'Imagen'),
            width: 75,
            customRender: (parameterValue, allRowData) => <CustomRenderImageToolTip className='table_products_image' value={parameterValue} allRowData={allRowData} />
        },
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 75
        },
        {
            id: 'reference',
            dataKey: 'reference',
            label: t('reference', 'Referencia'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('reference', 'Referencia') }
            },
            minWidth: 135
        },
        {
            id: 'name',
            dataKey: 'ProductLangs.name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            },
            minWidth: 130
        },
        {
            id: 'price',
            dataKey: 'SpecificPriceRuleId',
            label: (props) => {
                const myValue = parseInt(props.selectedFilterValue || props.value || defaultSpecificPriceRuleId)
                return <span>{t('price', 'Precio') + ' (' + (specificPriceRules?.dictionary?.[myValue]?.name || t('notSelectedPriceRule', 'Sin tarifa selec.')) + ')'} </span>
            },
            simpleLabel: t('price', 'Precio'),
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSingle',
                extraComponentData: { items: specificPriceRules?.dictionary || {}, label: t('specificPriceRule', 'Tarifa') }
            },
            minWidth: 150,
            generalSearchable: false,
            customRender: (_parameterValue, allRowData) => {
                return <DisplayPriceGettingSpecificPriceParams value={allRowData?.calculated_price} CurrencyId={specificPriceRules?.dictionary[allRowData.SpecificPriceRuleId]?.CurrencyId || ''} with_vat={false} specificPriceRules={specificPriceRules} SpecificPriceRuleId={defaultSpecificPriceRuleId} />
            }
        },
        {
            id: 'active',
            dataKey: 'active',
            label: t('active', 'Activo'),
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={45} />,
            hideColumnByDefault: true,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSingle',
                extraComponentData: { items: productActiveDict, label: t('active', 'Activo') }
            },
            generalSearchable: false
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} icon={!allRowData?.active ? faRotateLeft : undefined} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTableLink createRowDataLink={[locations.addon, ['$id', 'main']]} name='addons' columns={columns} getDataFrom='/api/app/product/getAllProductsComplete' extraWhereParams={{ productType: 5 }} extraWhereSubstituibleParams={{ 'SpecificPriceRuleId': defaultSpecificPriceRuleId }} setTableInstance={setTableInstance} onRowClick={onRowClick} />
    )
}


export default TableAddons